import React from 'react'
import AccountStepper from './AccountStepper';
import { useParams } from 'react-router';

const AccountList = ({ parentErrorStepIndex, setParentErrorStepIndex, parentStep, setActiveParentStep, setActiveChildStep, activeChildStep, formAccountData, setFormAccountData}) => {
   
    const { id } = useParams();
    let userGetId = localStorage.getItem('user_get_id')
    const userId = id ? id : userGetId;
    // let loginId = localStorage.getItem('login_id');


    return (
        <>
            <AccountStepper
                setParentErrorStepIndex={setParentErrorStepIndex}
                parentErrorStepIndex={parentErrorStepIndex}
                userId={userId}
                setActiveChildStep={setActiveChildStep}
                activeChildStep={activeChildStep}
                formAccountData={formAccountData}
                setFormAccountData={setFormAccountData}
                parentStep={parentStep}
                setActiveParentStep={setActiveParentStep}
            />
        </>
    )
}

export default AccountList;